import { Stack } from "@mui/material";
import React, { useEffect } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import { useLocation } from "react-router-dom";
import CertificateCard from "../CertificateCard/CertificateCard";
import BlogcardSection from "./BlogcardSection";
import BlogSection2 from "./BlogSection2";

const BlogMainSection = () => {
  // Scroll to the top on reload
  useEffect(() => {
    window.scrollTo(0, 0); // Ensure the page scrolls to the top on reload
    if (window.location.hash) {
      // Remove any hash in the URL
      window.history.replaceState(null, null, " ");
    }
  }, []);
  return (
    <>
      <Header />

      <main>
        <BlogSection2 />
      </main>
      <CertificateCard />
      <Footer />
    </>
  );
};

export default BlogMainSection;
